import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import TLN_1200 from './TrueLibertyNorth_1200.jpg';
import TLN_950 from './TrueLibertyNorth_950.jpg';
import TLN_680 from './TrueLibertyNorth_680.jpg';
import TLN_560 from './TrueLibertyNorth_560.jpg';
import './App.css';
import Nav from './Nav';
import Footer from './Footer';
import HomePage from './pages/Home';
import PodcastsPage from './pages/Podcasts';
import TranscriptsPage from './pages/Transcripts';
import TranscriptPage from './pages/TranscriptPage';
// import ResourcesPage from './pages/Resources';
import GreatQuotesPage from './pages/GreatQuotes';
import ResourcePage from './pages/ResourcePage';
// import SermonLinksPage from './pages/SermonLinks';
import MediaLinksPage from './pages/MediaLinks';
import PageNotFound from './pages/PageNotFound';
// import useWindowSize from './useWindowSize';




function Header() {
  return (
    <header>
      <Link to="/" title="Home Page" className="link">
    	<img src={TLN_1200} 
        alt="True Liberty North Banner" 
        id="banner"
        // srcSet="./TrueLibertyNorth_560.jpg 560w, ./TrueLibertyNorth_680.jpg 680w, ./TrueLibertyNorth_950.jpg 950w, ./TrueLibertyNorth_1200.jpg 1200w"
        srcSet={`${TLN_560} 560w, ${TLN_680} 680w, ${TLN_950} 950w, ${TLN_1200} 1200w`}
        />
        </Link>
  	</header>
  );
};

function App() { // <Route path='/:transcriptId/:scriptId' element={<TranscriptPage />} />
  // const {width, height} = useWindowSize();
  // console.log("width", width, "height", height);
  return ( // <Route path='/:transcriptId/:quoteId' element={<TranscriptPage />} />
    <>
    <BrowserRouter>
    <Header />
    <Nav />
    <Routes>
         <Route path='/' element={<HomePage />} />
         <Route path='/Podcasts' element={<PodcastsPage />} />
         <Route path='/Transcripts' element={<TranscriptsPage />} />
         <Route path='/GreatQuotes' element={<GreatQuotesPage />} />
         <Route path='/MediaLinks' element={<MediaLinksPage />} />
         <Route path='/:articleId/:quoteId' element={<ResourcePage />} />
         <Route path='/Transcripts/:trArticleId/:trquoteId' element={<TranscriptPage />} />
         <Route path='*' element={<PageNotFound />} />
    </Routes>
    <Footer />
    </BrowserRouter>
    </>
  );
};

export default App;